import * as tslib_1 from "tslib";
import highlightDisplayText, { dehighlightDisplayText, } from 'owa-mail-search-view/lib/utils/highlightDisplayText';
import React from 'react';
import { observer } from 'mobx-react';
var styles = require('../SearchBoxPillWell.scss');
var suggestionStyles = require('../SuggestionsContextMenu.scss');
var TextSegmentPart = /** @class */ (function (_super) {
    tslib_1.__extends(TextSegmentPart, _super);
    function TextSegmentPart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextSegmentPart.prototype.render = function () {
        var segment = this.props.segment;
        var highlightTextRegions = highlightDisplayText(segment.DisplayText);
        return (React.createElement("div", { className: styles.segmentName, title: dehighlightDisplayText(segment.DisplayText) }, highlightTextRegions.filter(function (e) { return e.text.length > 0; }).map(function (e) {
            var className = e.isHighlighted
                ? suggestionStyles.keywordMatchSuggestion
                : suggestionStyles.keywordNonMatchSuggestion;
            return React.createElement("div", { className: className }, e.text);
        })));
    };
    TextSegmentPart = tslib_1.__decorate([
        observer
    ], TextSegmentPart);
    return TextSegmentPart;
}(React.Component));
export default TextSegmentPart;
//# sourceMappingURL=TextSegmentPart.js.map